<template>
  <li :class="{'completed': learningUnit.is_complete}">
    <i class="k-asset-icon" :class="getAssetIcon('learning_unit')" aria-hidden="true"></i>
    <router-link :to="{ name: 'module_lu', params: { moduleId: moduleId, moduleLuId: learningUnit.id }}">
      {{ learningUnit.name }}
    </router-link>
    <i v-if="learningUnit.is_complete" class="fas fa-check" aria-hidden="true"></i>
    <router-link class="view-content btn btn-outlined" :to="{ name: 'module_lu', params: { moduleId: moduleId, moduleLuId: learningUnit.id }}">
      View content <i class="fas fa-long-arrow-alt-right" aria-hidden="true"></i>
    </router-link>
    <div class="download-button">
      <a type="button" :href="luDownloadUrl" class="btn btn-primary" aria-label="Download learning unit" title="Download learning unit">
        <i class="fas fa-cloud-download-alt" aria-hidden="true"></i>
      </a>
    </div>

  </li>
</template>

<script>
import AssetIconMixin from '@mixins/asset-icon-mixin';

export default {
  mixins: [AssetIconMixin],

  props: {
    learningUnit: {
      type: Object,
      required: true,
    },
    moduleId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    luDownloadUrl() {
      return `/api/static/learning_unit/${this.learningUnit.id}/zip`;
    },
  },
};
</script>
